/**
 * @generated SignedSource<<66dacc62fa5be4d5dae047f5a0eb50bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RatesAndInternalCostLitePage_project$data = {
  readonly id: string;
  readonly budgetType: BUDGET_TYPE | null;
  readonly flatRate: number | null;
  readonly flatCost: number | null;
  readonly " $fragmentType": "RatesAndInternalCostLitePage_project";
};
export type RatesAndInternalCostLitePage_project$key = {
  readonly " $data"?: RatesAndInternalCostLitePage_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RatesAndInternalCostLitePage_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RatesAndInternalCostLitePage_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flatRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flatCost",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "aaafbc8bdcd73a1b4d2c4bf6b99fb5b2";

export default node;
